import _asyncToGenerator from "/var/www/verifynest/resources/assets/js/qportal/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/var/www/verifynest/resources/assets/js/qportal/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import VueMoment from 'vue-moment';
export default /*#__PURE__*/(function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var app, Vue;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            app = _ref.app, Vue = _ref.Vue;
            Vue.use(VueMoment);

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
})();